import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { SHOP_TO_BUY_LOGGED_OUT_250513 } from "@faire/web-api--source/indigofair/settings/SHOP_TO_BUY_LOGGED_OUT_250513";

export const useSettingShopToBuyLoggedOut = (): boolean =>
  useSetting(SHOP_TO_BUY_LOGGED_OUT_250513, false);

export const useAssignSettingShopToBuyLoggedOut = () =>
  useAssignSetting(SHOP_TO_BUY_LOGGED_OUT_250513);
